export default __webpack_public_path__ + "static/media/IkonSparegrisSort.93626387.svg";